import React, { useEffect, useState } from 'react';
import HeaderSCI from './HeaderSCI';

import './recursocontable.css';
import './armonizacionContable.css';
import './recursoContableModern.css';

const principios = [
  {
    id: 1,
    color: '#621132',
    title: "Ejercicio fiscal 2025.",
    items: [

       {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1%C2%B0_Informe_Trimestral_2025.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_Informe_Trimestral_2025.pdf"
          },
          {
            label: "3ro. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Estado%20Anal%C3%ADtico%20de%20Ingresos%20Presupuestales2025.pdf"
          },
        
        ]
      },
       {
        label: "Egresos",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1%C2%B0_Informe_Trimestral_Egreso2025.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_Informe_Trimestral_Egreso2025.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ESTADO%20DE%20PRESUPUESTO%205%20AL%20MILLAR%20ESTATALE2025.pdf"
          },
           {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2025/egresos/Estado del Ejercicio del Presupuesto por Capítulo del Gasto 5 al Millar Estatal.pdf"
          }
        ]
      },
   
   
   
      
     
    ]
  },

 {
    id: 2,
    color: '#9e2348',
    title: "Ejercicio fiscal 2024.",
     items: [

       {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1er_TRIMESTRE_INGRESOS_5M_ESTATAL_2024.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_TRIMESTRE_INGRESOS_5M_ESTATAL_2024.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3er._Informe_Trimestral_de_Ingresos_5M_Estatal_2024.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4to._Informe_Trimestral_de_Ingresos_5M_Estatal_2024.pdf"
          },
          {
            label: "INFORME ANUAL INGRESOS 5M ESTATAL 2024",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_INGRESOS_5M_ESTATAL_2024.pdf"
          }          
        ]
      },
       {
        label: "Egresos",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1er_TRIMESTRE_EGRESOS_5M_ESTATAL_2024.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_TRIMESTRE_EGRESOS_5M_ESTATAL_2024.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3er._Informe_Trimestral_de_Egresos_5M_Estatal_2024.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4to._Informe_Trimestral_de_Egresos_5M_Estatal_2024.pdf"
          },
          {
            label: "INFORME ANUAL EGRESOS 5M ESTATAL 2024",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_EGRESOS_5M_ESTATAL_2024.pdf"
          },
         
        ]
      },
    
    
     
    ]
  },
  {
    id: 3,
    color: '#a98188',
    title: "Ejercicio fiscal 2023.",
     items: [


              {
        label: "Ingresos",
        
        subitems: [
            {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_5M_ESTATAL_2023.pdf"
          },

           
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_EGRESOS_5M_ESTATAL_2023.pdf"
          }
         
        ]
      },
       {
        label: "Egresos",
        subitems: [
           
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1er_TRIMESTRE_EGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_TRIMESTRE_EGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3er_TRIMESTRE_EGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4to_TRIMESTRE_EGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_EGRESOS_5M_ESTATAL_2023%20(1).pdf"
          },
        
        ]
      },
            
     
    ]
  },
{
    id:4,
    color: '#a98188',
    title: "Ejercicio fiscal 2022.",
     items: [

        {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_ESTATAL_2022.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_ESTATAL_2022.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_ESTATAL_2022.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_ESTATAL_2022.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_INGRESOS_5M_ESTATAL_2022.pdf"
          },
                   
        ]
      },
       {
        label: "Egresos",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          

      
        ]
      },
     
     
     
      
     
    ]
  },
  {
    id:5,
    color: '#a98188',
    title: "Ejercicio fiscal 2021.",
     items: [
      

        {
        label: "Ingresos",
              
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_2021.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_ESTATAL_2021.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_ESTATAL_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_ESTATAL_2021.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_INGRESOS_ANUAL_ESTATAL_2021.pdf"
          },
         
        ]
      },
       {
        label: "Egresos",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_EGRESOS_2021.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_EGRESOS_5M_ESTATAL_2021.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_EGRESOS_5M_ESTATAL_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_EGRESOS_5M_ESTATAL_2021.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_EGRESOS_ANUAL_5M_ESTATAL_2021.pdf"
          },
        

        ]
      },
     
     
 
      
     
    ]
  },

   {
    id:6,
    color: '#a98188',
    title: "Ejercicio fiscal 2020",
     items: [

       {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_2020.pdf",
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_2020.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_2020.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_2020.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ANUAL_INGRESOS_2020.pdf"
          },
         
        ]
      },
       {
        label: "Egresos",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_EGRESOS_2020.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_EGRESOS_2020.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_EGRESOS_2020.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO%20TRIMESTRE%20EGRESOS%202020.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ANUAL_EGRESOS_2020.pdf"
          },

        
        ]
      },
     
    

      
     
    ]
  },

 {
    id:7,
    color: '#a98188',
    title: "Ejercicio fiscal 2019",
     items: [

       {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_2019.pdf",
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_2019.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_2019.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_2019"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ANUAL_INGRESOS_2019.pdf"
          },
         
        ]
      },
       {
        label: "Egresos",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_EGRESOS_2019.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_EGRESOS_2019.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_EGRESOS_2019.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_EGRESOS_2019.pdf"
          },
           {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ANUAL_EGRESO_%202019.pdf"
          },

        
        ]
      },
     
    

      
     
    ]
  },



];

const RecursoContable = () => {
  const [expandedId, setExpandedId] = useState(
    principios[0]?.id ?? null
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleAccordion = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  const cleanLabel = (label = '') => {
    return label.replace(/\*/g, '').trim();
  };

  return (
    <main className="recurso-page">

      <div className="container recurso-shell">

        <div className="recurso-pill-wrap">
          <div className="recurso-pill">
            Recurso Estatal 5 al Millar
          </div>
        </div>

        <div className="recurso-heading">
          <h1>EJERCICIOS</h1>
          <span className="recurso-heading-line" />
        </div>

        <section
          className="recurso-accordion"
          aria-label="Ejercicios fiscales"
        >
          {principios.map((prin) => {
            const isExpanded = expandedId === prin.id;

            const hasDocuments =
              Array.isArray(prin.items) &&
              prin.items.length > 0;

            return (
              <article
                key={prin.id}
                className={`recurso-year-card ${
                  isExpanded ? 'is-open' : ''
                }`}
              >

                <button
                  type="button"
                  className="recurso-year-header"
                  onClick={() => toggleAccordion(prin.id)}
                  aria-expanded={isExpanded}
                  aria-controls={`recurso-panel-${prin.id}`}
                >
                  <span
                    className="recurso-year-icon"
                    style={{
                      backgroundColor:
                        prin.color || '#621132'
                    }}
                  >
                    <i className="fa-solid fa-file-invoice-dollar" />
                  </span>

                  <span className="recurso-year-title">
                    {prin.title}
                  </span>

                  <span className="recurso-year-chevron">
                    <i
                      className={`fa-solid ${
                        isExpanded
                          ? 'fa-chevron-up'
                          : 'fa-chevron-down'
                      }`}
                    />
                  </span>
                </button>

                <div
                  id={`recurso-panel-${prin.id}`}
                  className={`recurso-panel ${
                    isExpanded ? 'is-open' : ''
                  }`}
                >
                  <div className="recurso-panel-inner">

                    {hasDocuments ? (
                      <div className="recurso-grid">

                        {prin.items.map((item, idx) => {
                          const itemLabel =
                            cleanLabel(item.label);

                          const subitems =
                            Array.isArray(item.subitems)
                              ? item.subitems
                              : [];

                          return (
                            <section
                              className="recurso-category"
                              key={`${prin.id}-${idx}`}
                            >

                              <div className="recurso-category-heading">
                                <span className="recurso-category-dot" />
                                <h2>{itemLabel}</h2>
                              </div>

                              {subitems.length > 0 ? (
                                <ul className="recurso-doc-list">

                                  {subitems.map(
                                    (subitem, subIdx) => {
                                      const label =
                                        cleanLabel(
                                          subitem.label
                                        );

                                      const hasUrl =
                                        Boolean(
                                          subitem.url &&
                                          subitem.url.trim()
                                        );

                                      return (
                                        <li
                                          key={`${prin.id}-${idx}-${subIdx}`}
                                        >
                                          {hasUrl ? (
                                            <a
                                              href={subitem.url}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <i className="fa-regular fa-file-pdf" />
                                              <span>{label}</span>
                                            </a>
                                          ) : (
                                            <span className="recurso-doc-disabled">
                                              {label}
                                            </span>
                                          )}
                                        </li>
                                      );
                                    }
                                  )}

                                </ul>
                              ) : item.url ? (
                                <a
                                  className="recurso-single-link"
                                  href={item.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Consultar documento
                                </a>
                              ) : (
                                <p className="recurso-empty">
                                  Sin documentos disponibles.
                                </p>
                              )}

                            </section>
                          );
                        })}

                      </div>
                    ) : (
                      <p className="recurso-empty recurso-empty--panel">
                        No hay documentos disponibles.
                      </p>
                    )}

                  </div>
                </div>

              </article>
            );
          })}
        </section>

      </div>

    </main>
  );
};

export default RecursoContable;